// NPM Imports
import React, { Fragment } from "react";

// Components Imports
import { QuotationSignedOwnerBtns } from "../QuotationTopBarBtns";

// Declarations

export default function QuotationSignedOwnerStage(props) {
  return (
    <Fragment>
      <div className="document-meta">
        <div
          data-test="quotationtopbarbtns-document-meta"
          className="document-btns">
          <QuotationSignedOwnerBtns {...props} />
        </div>
      </div>
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV2/QuotationStages/QuotationSignedOwnerStage.js